
import React, { useEffect, useState } from "react";
import { Alert, Button, Col, Container, OffcanvasBody, OffcanvasHeader, Row, Table } from "reactstrap";
import DefaultOffCanvas from "../DefaultOffCanvas";
import form from 'formConfigs/calculator';
import DynamicForm from "components/DynamicForm";
import styles from "./style.module.scss"
import cx from "classnames";
import { getPackageFinalWeight, toNumberFormat } from "utils/Utils";
import { getUserPrices } from "api/PriceApi";
import { trackEvent } from "utils/Analytics";
import { ANALYTIC_EVENT_ACTIONS, ANALYTIC_EVENT_CATEGORIES } from "utils/Constants";

const CalculatorOffCanvas = props => {
    const { wrapper, btnColor = "primary", className, adviseData, poBox, onSave } = props;
    const [isOpen, setOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [result, setResult] = useState([]);
    const [prices, setPrices] = useState([]);
    const [calculatorData, setCalculatorData] = useState({});
    const ButtonWrapper = wrapper || "Button";

    useEffect(() => {
        loadPriceList();
    }, []);

    const loadPriceList = async () => {
        const prices = await getUserPrices();
        const defaultPrice = prices.find(p => p.isDefault);
        if (defaultPrice) {
            setCalculatorData({ priceType: defaultPrice.id })
        }
        setPrices(prices);
    }

    const toogleOffCanvas = (newState) => {
        setOpen(newState);
        if (newState == false) {
            onCanvasClosed();
        } else {
            trackEvent(ANALYTIC_EVENT_CATEGORIES.USER, ANALYTIC_EVENT_ACTIONS.OPEN_MODAL, "Calcula envio de Paquete")
        }
    }

    const onCanvasClosed = () => {
        setOpen(false);
        setResult([]);
    }
    const calculateTaxCost = (formData) => {
        const cost = Number(formData.cost);
        const tax = Number(formData.tax);
        const taxPercentage = (tax / 100) + 1;
        return Number(cost * taxPercentage).toFixed(2);
    }

    const calculateShippingCost = (formData, priceType) => {
        const packageWeight = getPackageFinalWeight(formData.weigth);
        const priceTable = JSON.parse(priceType.priceTable);
        const priceFactor = priceTable.reduce((a, p) => {
            return (Math.abs(p.weight - packageWeight) < Math.abs(a.weight - packageWeight) ? p : a);
        }, { weight: 0, price: 0 });
        return Number(priceFactor.price * packageWeight).toFixed(2);
    }

    const calculatePackage = (formData) => {
        const resultTable = Array();
        setIsLoading(true);
        const priceType = prices.find(p => p.id === formData.priceType);

        const shippingCost = calculateShippingCost(formData, priceType);
        const shippingCostDescription = priceType.isAllInclusive ? "Costo de envio e impuestos" : "Costo de Envio";
        resultTable.push({ description: shippingCostDescription, price: shippingCost, allInclusive: priceType.isAllInclusive });

        if (!priceType.isAllInclusive) {
            const taxCost = calculateTaxCost(formData);
            resultTable.push({ description: "Impuestos", price: taxCost, allInclusive: false });
        }

        setResult(resultTable);
        setIsLoading(false);
    }

    const getFormConfig = () => {
        return form;
    }

    const getGranTotal = (result) => {
        return result.reduce((a, r) => {
            const total = Number(a) + Number(r.price);
            return total.toFixed(2);
        }, Number(0))
    }

    const getCostTableData = (result) => {
        return result.map((r, index) => {
            return (
                <tr>
                    <td>{index + 1}</td>
                    <td>{r.description}</td>
                    <td className={styles.tablePriceColumn}>{toNumberFormat(r.price)} USD </td>
                </tr>
            )
        });
    }

    const updateFormData = (fieldName, value) => {
        setCalculatorData(prev => {
            return {
                ...prev,
                [fieldName]: value
            }
        })
    }

    const onInputChange = (inputName, value, event) => {
        setResult([]);
        if (inputName == "tax") {
            updateFormData("taxLabel", event.label)
        }
    }

    return (
        <>
            <ButtonWrapper
                color={btnColor}
                className={cx([className, styles.button])}
                onClick={() => toogleOffCanvas(!isOpen)}
            >
                {props.children}
            </ButtonWrapper>
            <DefaultOffCanvas
                direction="end"
                isOpen={isOpen}
                onClosed={onCanvasClosed}
                toggle={() => toogleOffCanvas(!isOpen)}
            >
                <OffcanvasHeader className={styles.offCanvasHeader} toggle={onCanvasClosed}>
                    Calculadora de Costo
                </OffcanvasHeader>
                <OffcanvasBody>
                    <Container>
                        <DynamicForm
                            id="calculatorCost"
                            externalFormState={calculatorData}
                            useExternalState={true}
                            onStateChange={setCalculatorData}
                            formConfig={getFormConfig()}
                            onSubmit={calculatePackage}
                            isLoading={isLoading}
                            onInputChange={onInputChange}>
                            <Container>
                                <Row>
                                    <Col>
                                        <Button
                                            className="float-end"
                                            type="submit"
                                            color="success">
                                            Calcular Costo
                                        </Button>
                                    </Col>
                                </Row>

                                {result.length > 0 && (
                                    <>
                                        <Table className={styles.productTable}>
                                            <thead>
                                                <tr>
                                                    <th className="col-2"> Linea</th>
                                                    <th className="col-7"> Description</th>
                                                    <th className={cx(["col-3", styles.tablePriceColumn])}> Precio</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {getCostTableData(result)}
                                            </tbody>
                                        </Table>
                                        <Row>
                                            <Col sm={{
                                                offset: 6,
                                                size: 6
                                            }} >
                                                <Table className={styles.summaryTable}>
                                                    <tbody>
                                                        <tr>
                                                            <td>Total</td>
                                                            <td>{getGranTotal(result)} USD</td>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                            </Col>
                                        </Row>

                                        <Alert color="warning">
                                            * Los montos mostrado en esta calculadora podrian no reflejar
                                            el montos total de envio e impuestos del paquete y el monto mostrato en esta calculadora
                                            debe tomarse como un monto de referencias. Para obtener una cotizacion exacta para un paquete
                                            por favor contacta a nuestro personal de servicio al cliente
                                        </Alert>
                                    </>
                                )}
                            </Container>
                        </DynamicForm>
                    </Container>
                </OffcanvasBody>
            </DefaultOffCanvas>
        </>
    );
}
export default CalculatorOffCanvas;
